import { https } from "../http";
import store from "../store";
import { setAddbillingclientLoading, setAllBillingclient,setLoading } from "../store/reducers/billingclient";

import { decrypt, showError } from "../utils/index";



// POST
const createBillingClient = async (data, callback) => {
    try {
      store.dispatch(setAddbillingclientLoading(true));
      let response = await https().post("billingclient/", data);
  
      if (response?.status === 200) {
       // getReports(false);
        callback?.();
      }

      return response

    } catch (error) {
      store.dispatch(setAddbillingclientLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
    }
  };


//   const getBillingClient = async ( showLoading = true) => {
//     try {
//       if (showLoading) store.dispatch(setLoading(true));
//       let response = await https().get(`billingclient/all`);
  
//       if (response?.status === 200) {
// console.log('response?.data',response?.data);



//         store.dispatch(setAllBillingclient(response?.data));
//       }
//     } catch (error) {
//       store.dispatch(setLoading(false));
//       showError(error?.response?.data?.message, error?.response?.status)
//     }
//   };


const getBillingClient = async (showLoading = true) => {
  try {
      if (showLoading) store.dispatch(setLoading(true));

  
      let response = await https().get('billingclient/all');

    
      if (response?.status === 200) {
          console.log('response?.data', response?.data);

          // Process the response data
          const processedBillingClients = response.data.billingclient?.map(client => {
              if (client.payerId) {
                  const processedPayers = client.payerId.map(payer => {
                      if (payer.patients) {
                          const processedPatients = payer.patients.map(patient => {
                          
                              return {
                                  ...patient,
                                  form1: decrypt(patient.form1),
                                  form2: decrypt(patient.form2),
                                  form3: decrypt(patient.form3),
                              };
                          });
                          return {
                              ...payer,
                              patients: processedPatients,
                          };
                      }
                      return payer;
                  });
                  return {
                      ...client,
                      payerId: processedPayers,
                  };
              }
              return client;
          });

          console.log('processedBillingClients',processedBillingClients);
          
          // Dispatch the processed data to Redux store
          store.dispatch(setAllBillingclient(processedBillingClients));

      }
  } catch (error) {
  
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
  } finally {
      
      if (showLoading) store.dispatch(setLoading(false));
  }
};

  const editBillingclient = async (data, showLoading = true) => {
    try {
      store.dispatch(setLoading(true));
      let response = await https().put(`/billingclient/${data?.id}`, data);
  
      if (response?.status === 200) {
        getBillingClient(showLoading);
      }
  
      return response
    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status)
    }
  };

  export {
    createBillingClient,
    getBillingClient,
    editBillingclient
  }